import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ACTION_FILTER_TYPE_M;
export var ACTIONS;
(function (ACTIONS) {
  ACTIONS["SHOW_BUNDLES"] = "showBundles";
  ACTIONS["SHOW_POPULAR_BRANDS"] = "showPopularBrands";
  ACTIONS["REDIRECT"] = "redirect";
  ACTIONS["SHOW_PRICE_RANGE"] = "showPriceRange";
  ACTIONS["SHOW_YEAR_RANGE"] = "showYearRange";
  ACTIONS["RECENT_ACTIVITY"] = "showRecentActivity";
})(ACTIONS || (ACTIONS = {}));
export var ACTION_FILTER_TYPE_MAPPING = (_ACTION_FILTER_TYPE_M = {}, _defineProperty(_ACTION_FILTER_TYPE_M, ACTIONS.SHOW_POPULAR_BRANDS, 'make'), _defineProperty(_ACTION_FILTER_TYPE_M, ACTIONS.SHOW_PRICE_RANGE, 'price'), _defineProperty(_ACTION_FILTER_TYPE_M, ACTIONS.SHOW_YEAR_RANGE, 'm_year'), _ACTION_FILTER_TYPE_M);
export var SOURCES;
(function (SOURCES) {
  SOURCES["HOME_PAGE_FILTER"] = "homePageFilter";
  SOURCES["HOME_PAGE_FILTER_BUDGET"] = "homePageFilterBudget";
  SOURCES["HOME_PAGE_FILTER_BRAND"] = "homePageFilterBrand";
})(SOURCES || (SOURCES = {}));
export var DEFAULT_ROW_COUNT_CARDS_MOBILE = 2;
export var DEFAULT_ROW_COUNT_CARDS_DESKTOP = 4;
export var MAX_WIDTH_POPULAR_BRANDS = 100;
export var THRESHOLD_POPULAR_BRANDS = 3;
export var popularBrandActions = [ACTIONS.SHOW_POPULAR_BRANDS, ACTIONS.SHOW_PRICE_RANGE, ACTIONS.SHOW_YEAR_RANGE];
export var rangeSources = [SOURCES.HOME_PAGE_FILTER, SOURCES.HOME_PAGE_FILTER_BRAND, SOURCES.HOME_PAGE_FILTER_BUDGET];
export var SLIDES_TO_SCROLL_DESKTOP = 4;
export var SLIDES_TO_SHOW_DESKTOP = 4.2;
export var SLIDES_TO_SCROLL_MOBILE = 1;
export var SLIDES_TO_SHOW_MOBILE = 2;
export var LOADING_CARDS_COUNT_DESKTOP = 4;
export var LOADING_CARDS_COUNT_MOBILE = 2;
export var popularDataUrlPath = '/api/bxp/popular-data';
export var POPULAR_BRANDS_ERROR_TEXT = 'Error while getting data. Please try after some time.';